import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {BfqQuestions} from '../../../shared/constants/constants';
import {BfqOption} from '../../../shared/models/bfq-option';
import {TestsService} from '../../../shared/services/tests.service';
import {ActivatedRoute} from '@angular/router';
import {StorageHelper} from '../../../shared/helpers/storage-helper';
import {TestBaseQuestions} from '../../test-base/test-base-questions';
import {Store} from '@ngrx/store';
import {State} from '../../../shared/store';

@Component({
    selector: 'app-test-bfq-questions',
    templateUrl: './test-bfq-questions.component.html',
    styleUrls: ['./test-bfq-questions.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestBfqQuestionsComponent extends TestBaseQuestions<number> {
    constructor(private testsService: TestsService,
                private route: ActivatedRoute,
                store: Store<State>) {
        super(store);
    }

    get currentQuestion(): BfqOption {
        return BfqQuestions[this.currentIndex];
    }

    get questionsLength(): number {
        return BfqQuestions.length;
    }

    get code(): string {
        return this.route.snapshot.params.code;
    }

    save(): void {
        this.testsService
            .saveBfqTest(this.code, this.answers)
            .subscribe(x => {
                StorageHelper.clearTestData(this.code);
                this.nextStep();
            }, error => {
                this.handleTestError(error);
            });
    }
}
